import { render, staticRenderFns } from "./GlobalLoading.vue?vue&type=template&id=ea16f766&"
import script from "./GlobalLoading.vue?vue&type=script&lang=js&"
export * from "./GlobalLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports